import {useEffect} from "react";

import {GADataGetItemData, GADataGetItemFullData, GADataItems} from "./ga-data-transformer";
import analyticsService from "../../../../helpers/analytics.service";

export const trackViewShoppingCart = (items) => {
    useEffect(() => {
        let ignore = false;
        const gaDataItems = GADataItems(items);
        if (!ignore && Array.isArray(gaDataItems) && gaDataItems.length) {
            analyticsService.trackViewShoppingCart(gaDataItems);
        }

        return () => {
            ignore = true;
        }
    }, []);
}

export const trackClearCart = (items) => {
    const gaDataItems = GADataItems(items);
    if (gaDataItems !== undefined && Array.isArray(gaDataItems) && gaDataItems.length) {
        analyticsService.trackClearCart(gaDataItems);
    }
}

export const trackRemoveFromCart = (item) => {
    const gaDataItem = GADataGetItemData(item);
    if (gaDataItem !== undefined) {
        analyticsService.trackRemoveFromCart(gaDataItem);
    }
}

export const trackAddToCart = (item) => {
    const gaDataItem = GADataGetItemFullData(item);
    if (gaDataItem !== undefined) {
        analyticsService.trackAddToCart(gaDataItem);
    }
}

export const trackChangeQuantityToCart = (item) => {
    const gaDataItem = GADataGetItemFullData(item);
    if (gaDataItem !== undefined) {
        analyticsService.trackChangeQuantityToCart(gaDataItem);
    }
}
export const trackTelClickRequestArticleInformation = () => {
    analyticsService.trackTelClickRequestArticleInformation();
}